import { connect } from 'react-redux';
import { get } from 'lodash';
import React from 'react';

import NavigationBreadCrumb from '@commons/Breadcrumb/NavigationBreadCrumb';

import LossDataGrid from './components/LossDataGrid';

import { ComponentContainer } from './styledComponents';

export const StocksInventoriesLosses = (props) => {
  const { match } = props;

  const path = get(match, 'path');

  return (
    <ComponentContainer>
      <NavigationBreadCrumb featurePath={path} />
      <LossDataGrid />
    </ComponentContainer>
  );
};

StocksInventoriesLosses.propTypes = {};

const mapStateToProps = (state) => ({
  stores: state.baseReducer.activeStores,
});

export default connect(mapStateToProps)(StocksInventoriesLosses);
